import React, { useState } from "react";
// import Button from 'react-bootstrap/Button';
import Modal from "react-bootstrap/Modal";
import vplaceholder from "../../assets/imgs/laptop-img.webp";
import avatar from "../../assets/imgs/cgiar.webp";
import "./css/Video.css";

const VideoCTA = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <section id="videoDiv" className="videoPlay_section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 col-lg-6 mb-5 mb-cc-none">
              <button
                type="button"
                variant="primary"
                onClick={handleShow}
                className="btn videoplay-Btn"
                // data-bs-toggle="modal"
                // data-bs-target="#videoPlayModal"
                aria-label="Play Video Button"
              ></button>
              <img
                alt="nonprofit crm solution"
                src={vplaceholder}
                width="752"
                height="417"
                className="vplaceholder"
              />
            </div>
            <div className="col-md-6 col-lg-6" data-aos="zoom-out-right">
              <p>
                The project team demonstrated to be highly skilled, organized,
                friendly and most importantly very flexible! Their flexibility
                was very much appreciated by our team as they accommodated
                seamlessly to our changing schedules and requirements.
              </p>
              <div className="txtInfo">
                <img src={avatar} alt="Cgiar system organization" />
                <p>
                  Tania Jordan, Business Analysis Officer{" "}
                  <small>CGIAR System Organization</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Modal
        size="lg"
        show={show}
        onHide={handleClose}
        className="modal_getStartedForm"
      >
        <Modal.Header closeButton>
          Right Cause Nonprofit Solution- Automate Fundraising, Donations,
          Grants and Volunteers.
        </Modal.Header>
        {/* <Fcontact /> */}
        <iframe
          width="560"
          height="315"
          src="https://www.youtube.com/embed/j8g5v9GpakQ"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </Modal>
    </>
  );
};

export default VideoCTA;
